import { render, staticRenderFns } from "./ChannelCooperation.vue?vue&type=template&id=428eccc3&scoped=true&"
import script from "./ChannelCooperation.vue?vue&type=script&lang=js&"
export * from "./ChannelCooperation.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCooperation.vue?vue&type=style&index=0&id=428eccc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428eccc3",
  null
  
)

export default component.exports